import { buildHeaders, getApiBaseUrl } from '@/utils/getApiBaseUrl'
import axios, { AxiosInstance, AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'

// Create base axios instance
const apiService: AxiosInstance = axios.create({
  baseURL:getApiBaseUrl() ||  process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:3001',
  headers: {
    'Content-Type': 'application/json',
     ...buildHeaders('', 'apiService', ''),
    // 'Cache-Control': 'no-cache, no-store, must-revalidate',//public, max-age=900, stale-while-revalidate=60
    'Cache-Control': 'public, max-age=300, stale-while-revalidate=60',//
    // 'Pragma': 'no-cache',
    // 'Expires': '0'
  },
  timeout: 10000 // 10 seconds
})

// Request interceptor
apiService.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    // const token = localStorage.getItem('accessToken')
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("peoples_token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // Add cache-busting headers to prevent caching
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    
    // Add timestamp to prevent caching
    if (config.params) {
      config.params._t = Date.now();
    } else {
      config.params = { _t: Date.now() };
    }

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

// Response interceptor
apiService.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data
  },
  async (error: AxiosError) => {
    console.log('error=>error',error)
    // Handle 401 Unauthorized errors
    if (error.response?.status === 401) {
      // Clear localStorage
      localStorage.clear()

      // Redirect to login page
      window.location.href = '/auth/login'
    }


    return Promise.reject(error)
  }
)

// Common API methods
export const api = {
  get: <T>(url: string, params = {}) =>
    apiService.get<T>(url, { params }),

  post: <T>(url: string, data = {}, config?: AxiosRequestConfig) =>
    apiService.post<T>(url, data, config),

  put: <T>(url: string, data = {}) =>
    apiService.put<T>(url, data),

  delete: <T>(url: string) =>
    apiService.delete<T>(url)
}

export default apiService 